import api from "../Security/api";

class OrderStatusReasonDetailService {
    async updateOrderStatusReasonDetail(orderStatusReasonDetail) {
        return new Promise((res, reject) => {
            api
                .put("/orderStatusReasonDetails", orderStatusReasonDetail)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async createOrderStatusReasonDetail(orderStatusReasonDetail) {
        return new Promise((res, reject) => {
            api
                .post("/orderStatusReasonDetails", orderStatusReasonDetail)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    async deleteOrderStatusReasonDetail(id) {
        return new Promise((res, reject) => {
            api
                .delete("/orderStatusReasonDetails/" + id)
                .then((data) => {
                    res(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

}

const orderStatusReasonDetailService = new OrderStatusReasonDetailService();

export default orderStatusReasonDetailService;
